
import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { LoadingActionContext } from '@/contexts/layouts/LoadingActionContext';
import { LoadingContext } from '@/contexts/layouts/LoadingContext';
import { DefaultInstitutionCreateLink, DefaultParticipantCreateLink, DefaultTrialCreateLink, ILinkContext, LinkContext } from '@/contexts/layouts/LinkContext';
import { ShowLayoutContext } from '@/contexts/layouts/ShowLayoutContext';
import { useSearchParams } from 'react-router-dom';


interface IShowLayoutProviderProps { }

const ShowLayoutProvider: FC<PropsWithChildren<IShowLayoutProviderProps>> = ({ 
    children 
}) => {
    const [urlSearchParams] = useSearchParams();
    const [ context ] = useState(() => {
        return {
            showLayout: urlSearchParams.get("hide-layout") !== '1'
        }
    });

    return (
        <ShowLayoutContext.Provider value={context}>
            {children}
        </ShowLayoutContext.Provider>
    )
}

export default ShowLayoutProvider;